import ApeironComponent from '@/components/commons/apeiron-component.model';
import BecaService from '@/entities/seguimiento/beca.service';
import { ActividadRetribucion, BecarioActividadRetribucion, IBecarioActividadRetribucion } from '@/shared/model/ars/ars.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import { IBeca } from '@/shared/model/seguimiento/beca.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { IUsuarioRol } from '@/shared/model/usuarioRol';
import { EstadoSolicitud } from '@conacyt/perfil-usuario-client';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Component, Emit, Inject, Prop } from 'vue-property-decorator';

/**
 */
@Component
export default class ActividadBecariosArsComponent extends ApeironComponent {
  @Inject('becaService') private becaService!: () => BecaService;

  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  public actividadForm: ActividadRetribucion = new ActividadRetribucion();

  private consultandoBecas = false;
  private agregandoBecarios = false;

  public mostrarModalAgregar = false;

  public becarioResponsableId: string | null = null;
  public usuarios: Array<IUsuarioRol> = [];
  /**
   * Controles de tabla de becarios
   */
  public totalBecariosTabla = 0;
  public perPageBecariosTabla = 25;
  public currentPageBecariosTabla = 1;
  public filtroBecariosTabla = '';
  public becariosTabla: Array<BecarioActividadRetribucion> = [];
  public becariosTablaFiltrados: Array<BecarioActividadRetribucion> = [];
  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];
  public readonly fieldsBecariosTabla: BvTableFieldArray = [
    {
      key: 'responsable',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.responsable').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'numeroApoyo',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.numeroApoyo').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'becario.cvu',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.cvu').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'becario',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.nombre').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'periodoBeca.fechaInicioEstudios',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.fechaInicioEstudios').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'periodoBeca.fechaFinEstudios',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.fechaFinEstudios').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'periodoBeca.fechaInicioBeca',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.fechaInicioBeca').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'periodoBeca.fechaFinBeca',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.fechaFinBeca').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'periodoBeca.duracionBeca',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.duracionBeca').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.actividadesRetribucion.campos.acciones').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
  ];

  public mounted(): void {
    this.becariosTabla = BecarioActividadRetribucion.fromArray(this.solicitud.becariosRetribucion ?? []);
    this.becariosTablaFiltrados = this.becariosTabla;
  }

  public buscarEnTablaBecarios(): void {
    this.becariosTablaFiltrados = [];
    this.becariosTabla.forEach(becario => {
      if (this.filtroBecariosTabla) {
        if (
          (becario.numeroApoyo + '').toLowerCase().includes(this.filtroBecariosTabla.toLowerCase()) ||
          becario.becario?.cvu?.toLowerCase().includes(this.filtroBecariosTabla.toLowerCase()) ||
          becario.becario?.curp?.toLowerCase().includes(this.filtroBecariosTabla.toLowerCase()) ||
          becario.becario?.nombre?.toLowerCase().includes(this.filtroBecariosTabla.toLowerCase()) ||
          becario.becario?.apellidoPaterno?.toLowerCase().includes(this.filtroBecariosTabla.toLowerCase()) ||
          becario.becario?.apellidoMaterno?.toLowerCase().includes(this.filtroBecariosTabla.toLowerCase())
        ) {
          this.becariosTablaFiltrados.push(becario);
        }
      } else {
        this.becariosTablaFiltrados.push(becario);
      }
    });
  }

  public abrirModal(): void {
    this.mostrarModalAgregar = true;
  }

  public cerrarModal(): void {
    this.mostrarModalAgregar = false;
  }

  @Emit('changed')
  public emitirGuardado(actividadGuardada: ActividadRetribucion): ActividadRetribucion {
    return actividadGuardada;
  }

  public manejaBecariosSeleccionados(becas: Array<IBeca>): void {
    this.agregandoBecarios = true;
    this.mostrarModalAgregar = false;

    const becariosGuardar: Array<BecarioActividadRetribucion> = becas.map(
      beca => new BecarioActividadRetribucion(beca.id, beca.numeroApoyo, beca.becario, beca.periodoBeca, beca.solucionSolicitud)
    );

    this.becariosTabla = this.becariosTabla
      .concat(becariosGuardar)
      .filter((becario, index, self) => index === self.findIndex(b => b.becaId === becario.becaId));
    if (!this.becariosTabla.some(becario => becario.responsable)) {
      const primerBecario = this.becariosTabla[0];
      if (primerBecario) {
        primerBecario.responsable = true;
      }
    }
    this.becariosTablaFiltrados = this.becariosTabla;
    this.agregandoBecarios = false;
  }

  public guardarBecarios(): void {
    this.usuarios = this.solicitud.usuarios || [];
    this.usuarios = this.usuarios.filter(usuario => usuario.rol !== RolAutoridad.BECARIO);

    const becarioResponsable = this.becariosTabla.find(becario => becario.responsable);
    if (becarioResponsable) {
      const usuarioRol: IUsuarioRol = {
        cvu: becarioResponsable?.becario?.cvu,
        nombreCompleto:
          becarioResponsable?.becario?.nombre +
          ' ' +
          becarioResponsable?.becario?.apellidoPaterno +
          ' ' +
          becarioResponsable?.becario?.apellidoMaterno,
        rol: RolAutoridad.BECARIO,
      };
      this.usuarios.push(usuarioRol);
    }

    this.$emit('submit', { becariosRetribucion: this.becariosTabla, usuarios: this.usuarios });
  }

  get consultandoElBack(): boolean {
    return this.consultandoBecas || this.agregandoBecarios;
  }

  get esReadOnly(): boolean {
    return this.readOnly;
  }

  get esEscritura(): boolean {
    return (
      !this.readOnly &&
      EstadoSolicitud.EN_CAPTURA === this.solicitud.estado &&
      this.solicitud?.solicitante?.cvu == this.$store.getters.userInfo?.cvu
    );
  }

  public eliminarBecario(beca: IBecarioActividadRetribucion): void {
    this.becariosTabla = this.becariosTabla.filter(b => b.becaId !== beca.becaId);
    this.becariosTablaFiltrados = this.becariosTabla;
  }

  public seleccionarResponsable(becario: BecarioActividadRetribucion): void {
    this.becariosTabla.forEach(b => (b.responsable = false));
    becario.responsable = true;
  }
}
